import { React, useRef, useState, useEffect } from "react";
import fallbackImage from "assets/images/default.jpg";
import baseImage from "assets/images/base-template.jpg";

const Gallery = ({ gallery, bucket }) => {
	const FIXED_HEIGHT = 500; // Set your desired fixed height
	const scrollContainerRef = useRef(null);
	const [isDragging, setIsDragging] = useState(false);
	const [startX, setStartX] = useState(0);
	const [scrollLeft, setScrollLeft] = useState(0);

	// Calculate width based on aspect ratio and fixed height
	const calculateWidth = (image) => {
		if (image.width && image.height) {
			const aspectRatio = image.width / image.height;
			return FIXED_HEIGHT * aspectRatio;
		}
		// Fallback width if dimensions aren't available
		return 300;
	};

	// Handle mouse drag start
	const handleMouseDown = (e) => {
		setIsDragging(true);
		setStartX(e.pageX - scrollContainerRef.current.offsetLeft);
		setScrollLeft(scrollContainerRef.current.scrollLeft);
		scrollContainerRef.current.style.cursor = 'grabbing';
	};

	// Handle mouse drag end
	const handleMouseUp = () => {
		setIsDragging(false);
		if (scrollContainerRef.current) {
			scrollContainerRef.current.style.cursor = 'grab';
		}
	};

	// Handle mouse drag move
	const handleMouseMove = (e) => {
		if (!isDragging) return;
		e.preventDefault();
		const x = e.pageX - scrollContainerRef.current.offsetLeft;
		const walk = x - startX; // Direct 1:1 movement, no multiplier
		scrollContainerRef.current.scrollLeft = scrollLeft - walk;
	};

	// Handle touch events for mobile
	const handleTouchStart = (e) => {
		setIsDragging(true);
		setStartX(e.touches[0].pageX - scrollContainerRef.current.offsetLeft);
		setScrollLeft(scrollContainerRef.current.scrollLeft);
	};

	const handleTouchMove = (e) => {
		if (!isDragging) return;
		const x = e.touches[0].pageX - scrollContainerRef.current.offsetLeft;
		const walk = x - startX; // Direct 1:1 movement, no multiplier
		scrollContainerRef.current.scrollLeft = scrollLeft - walk;
	};

	const handleTouchEnd = () => {
		setIsDragging(false);
	};

	// Add global mouse up listener
	useEffect(() => {
		const handleGlobalMouseUp = () => {
			setIsDragging(false);
			if (scrollContainerRef.current) {
				scrollContainerRef.current.style.cursor = 'grab';
			}
		};

		document.addEventListener('mouseup', handleGlobalMouseUp);
		return () => document.removeEventListener('mouseup', handleGlobalMouseUp);
	}, []);

	return (
		<div className="relative">
			{gallery.length > 0 ? (
				
				<div className="relative">
					{gallery.length > 1 ? (

						<div
							ref={scrollContainerRef}
							className="flex overflow-x-auto overflow-y-hidden gap-4 pb-2 cursor-grab select-none px-4 pb-6"
							style={{ 
								height: `${FIXED_HEIGHT}px`,
								scrollbarWidth: 'thin'
							}}
							onMouseDown={handleMouseDown}
							onMouseUp={handleMouseUp}
							onMouseMove={handleMouseMove}
							onMouseLeave={handleMouseUp}
							onTouchStart={handleTouchStart}
							onTouchMove={handleTouchMove}
							onTouchEnd={handleTouchEnd}
						>
							{gallery.map((image, index) => (
								<div 
									key={index}
									className="flex-none"
									style={{ 
										width: 'auto',
										height: `${FIXED_HEIGHT}px`
									}}
								>
									<img 
										src={`//ps-images.imgix.net/${image.filename}?q=70&width=800)`} 
										alt='' 
										className="w-full h-full object-cover md:rounded-default pointer-events-none"
										draggable="false"
									/>
								</div>
							))}
						</div>

					) : (

						<>
							{gallery[0].filename ? (
								<>
								<div 
									style={{ 
										backgroundImage: `url(//ps-images.imgix.net/${gallery[0].filename}?q=70&width=800)`
									}}
									className="bg-cover bg-center w-full">	
									<img src={baseImage} alt='baseImage' className="opacity-0 block w-full h-auto" />
								</div>
								</>
							): (
								<>
								<div 
									className="bg-cover bg-center w-full">	
									<img src={baseImage} alt='baseImage' className="opacity-1 block w-full h-auto" />
								</div>
								</>
							)}
						</>
						
					)}
				</div>
			) : (
				<div 
					style={{ backgroundImage: `url(${fallbackImage})` }} 
					className="bg-cover bg-center absolute inset-0 w-full h-full">	
					<img src={baseImage} alt='baseImage' className="opacity-0 block" />
				</div>
			)}
		</div>
	);
};

export default Gallery;